import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import BookingForm from "./bookingForm";
import LocationAndRating from "./locationAndRating";

export default function DynamicBookingForm({ content }) {
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });
  const [submittedMobile, setSubmittedMobile] = useState(false);
  const [bookedMobile, setBookedMobile] = useState(false);

  useEffect(() => {
    if (content.backgroundColor) {
      const elements = document.querySelectorAll("#dynamicBookingForm");
      elements.forEach(element => {
        if (element.className === content.backgroundColor) {
          element.style.background = content.backgroundColor;
        }
      });
    }
  }, [content]);

  return (
    <div id="dynamicBookingForm" className={content.backgroundColor}>
      <div className="bookingFormContainer">
        {!isMobile && (
          <div className="bookingFormRight">
            <img alt="" src={content.bookingFormImage.url} />
          </div>
        )}
        <div className="bookingFormLeft">
          <div className="bookingFormTexts">
            <div className="title">{content.bookingFromTitle}</div>
            <div className="description">{content.bookingFormDescription}</div>
            {isMobile && (
              <div className="bookingFormRight">
                <img alt="" src={content.bookingFormImage.url} />
              </div>
            )}
          </div>
          <BookingForm
            service={content.bookingService}
            isMobile={isMobile}
            submittedMobile={submittedMobile}
            setSubmittedMobile={setSubmittedMobile}
            bookedMobile={bookedMobile}
            setBookedMobile={setBookedMobile}
            bufferTime={content.bufferTime}
            formUrl={content.formUrl}
          />
          <div
            className={`bookingFormBottom${
              bookedMobile && !submittedMobile
                ? " bookedMobile"
                : bookedMobile && setBookedMobile
                ? " submittedMobile"
                : ""
            }`}>
            {!bookedMobile && !submittedMobile && <LocationAndRating content={content} />}
          </div>
        </div>
      </div>
      <div className="introContainer">
        <div className="serviceImage">
          <img alt="" src={content.serviceImage.url} />
        </div>
        <div className="introText">
          <div className="introHeader">{content.introHeader}</div>
          <div className="introDescription" dangerouslySetInnerHTML={{ __html: content.introDescription }} />
        </div>
        <div className="introImage">
          <img alt="" src={content.introImage.url} />
        </div>
      </div>
    </div>
  );
}
